<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useTodayViewStore } from '@/stores/today-view';
import ShiftsTodayList from './shifts-today-list.vue';
import ShiftsTodaySummary from './shifts-today-summary.vue';

const { showSummary } = storeToRefs(useTodayViewStore());

// The persisted store keeps the boolean flag; the toggle exposes it as two
// named views, mirroring the Calendario/Agenda toggle of the shifts page.
const selectedView = computed({
  get: () => (showSummary.value ? 'summary' : 'list'),
  set: (value: 'list' | 'summary') => {
    showSummary.value = value === 'summary';
  },
});
</script>
<template>
  <div class="w-100">
    <div class="d-flex align-center px-4 mt-n4 mb-2">
      <v-btn-toggle
        v-model="selectedView"
        color="primary"
        density="compact"
        variant="outlined"
        divided
        mandatory
      >
        <v-btn
          value="list"
          size="small"
          aria-label="Lista"
        >
          <v-icon icon="mdi-format-list-bulleted" />
          <v-tooltip
            activator="parent"
            location="bottom"
          >
            Lista
          </v-tooltip>
        </v-btn>
        <v-btn
          value="summary"
          size="small"
          aria-label="Resumen con mapa"
        >
          <v-icon icon="mdi-map-marker-radius" />
          <v-tooltip
            activator="parent"
            location="bottom"
          >
            Resumen con mapa
          </v-tooltip>
        </v-btn>
      </v-btn-toggle>
    </div>
    <shifts-today-summary v-if="showSummary" />
    <shifts-today-list v-else />
  </div>
</template>
